function piv_markets_map(markers, target) {
	if (markers) {
		var map_styles = [
			{
				"featureType": "all",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"weight": "2.00"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#9c9c9c"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [
					{
						"color": "#f2f2f2"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "landscape.man_made",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [
					{
						"saturation": -100
					},
					{
						"lightness": 45
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#eeeeee"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#7b7b7b"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{
						"color": "#46bcec"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#c8d7d4"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#070707"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			}
		];

		var map_options = {
			zoom: 15,
			center: { lat: 0, lng: 0 },
			// disableDefaultUI: true,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: true,
			fullScreenControl: false,
			clickableIcons: false,
			styles: map_styles
		};

		var map = new google.maps.Map(target, map_options);

		var bounds = new google.maps.LatLngBounds();

		$(markers).each(function(index, marker) {
			var lat_lng = new google.maps.LatLng(marker.lat, marker.lng);
			var marker = new piv_markets_map_marker(lat_lng, marker.title, map);
			bounds.extend(lat_lng);
		});

		map.fitBounds(bounds);

	}
}

function piv_markets_map_marker(lat_lng, title, map) {
	this.lat_lng = lat_lng;
	this.title = title;
	this.setMap(map);
}

piv_markets_map_marker.prototype = new google.maps.OverlayView();

piv_markets_map_marker.prototype.draw = function() {
	var thisMarker = this;
	var div = this.div;
	if (!div) {
		div = this.div = document.createElement('div');
		div.className = 'piv-markets-map-marker';
		div.innerHTML = '<div class="piv-markets-map-marker-popup">' + this.title + '</div><div class="piv-markets-map-marker-pin"><svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill-rule="evenodd"><path class="arrow-bottom" d="m425.8 458.1c35.6-26.4 73-68 86.2-111.1-83.5 116.6-200.2 163.2-334.4 87.7-27.2-15.3-50.2-40.3-68.2-67.4l29.2-22.8c-79.1-34-86.6-37.3-138.6-59.6l18 149.5 31-23c40.8 44.9 80.9 70.6 136.2 88.9 79.3 26.3 174.7 6.7 240.6-42.2z" fill="#00a7cf"/><path class="arrow-top" d="m403.3 143.2c-4.9 6.6-22.7 17.8-30.2 23.6l138.9 60.3-18.1-150-31.5 23.2c-18.6-20.7-33.4-36.6-55.7-49.9-102-61-211.7-73.7-315.7 1.8-26.3 19.1-85.5 78.4-89.1 113.3 5.3-6.4 10.1-16.1 15.8-24 16.9-23.2 49.8-52.4 75.3-66.4 86.4-47.5 185-46.4 264.2 17.7 18.9 15.3 31.4 29.3 46.1 50.4z" fill="#FFFFFF"/></g></svg></div>';
		var panes = this.getPanes();
		panes.floatPane.appendChild(div);
	}
	var position = this.getProjection().fromLatLngToDivPixel(this.lat_lng);
	if (position) {
		div.style.left = position.x + 'px';
		div.style.top = position.y + 'px';
	}
};

piv_markets_map_marker.prototype.remove = function () {
	if (this.div) {
		this.div.parentNode.removeChild(this.div);
		this.div = null;
	}
};

piv_markets_map_marker.prototype.getPosition = function () {
	return this.lat_lng;
};

$(document).ready(function() {

	if ($('#autocomplete-form').length) {
		// get local timezone
		var today = new Date();
		var timezoneOffset = today.getTimezoneOffset();
		var offset = (timezoneOffset * 60) * -1;
		$('#address').attr('data-offset', offset);

		autocomplete();
		initialSearchForm();
	}

	// count statistics up from zero
	if ($('.piv-statistic-circles-group').length > 0) {
		$('.piv-statistic-circles-group').each(function(index, group) {
			var statistics = $('.piv-statistic-circle', group);
			$(statistics).each(function(index, statistic) {
				var target = $('.piv-statistic-circle-number', statistic)[0];
				var end_number = $(target).attr('data-number');
				var prefix = $(target).attr('data-prefix');
				var suffix = $(target).attr('data-suffix');
				var options = {
					startVal: 0,
					decimalPlaces: 0,
					duration: 3,
					useGrouping: true,
					useEasing: false,
					prefix: prefix,
					suffix: suffix,
					enableScrollSpy: true,
					scrollSpyOnce: true
				};
				var counter = new CountUp(target, end_number, options);
			});
		});
	}

	// open and close faqs
	$('.piv-faq-question').on('click', function() {
		console.log('hello');
		$(this).parent().toggleClass('piv-faq-active');
	});

	// markets map
	$('.piv-markets-map').each(function(index, map) {
		var markers = JSON.parse($(map).attr('data-markers'));
		piv_markets_map(markers, map);
	});

	// testimonials slider
	$('.piv-testimonial-cards-group').flickity({
		adaptiveHeight: false,
		cellAlign: 'left',
		contain: true,
		pageDots: true,
		percentPosition: true,
		wrapAround: true
	});

	// external monthly parking account login functionality
	if ($('.piv-monthly-parking-login').length > 0) {
		var group = $('.piv-monthly-parking-login');
		$('#states', group).on('change', function() {
			var state = $(this).val();
			// $('#cities option', group).hide();
			// $('#cities option[disabled]', group).prop('selected', true).show();
			// $('#cities option[data-state="' + state + '"]', group).show();
			$('#cities option', group).not('[value="#"]').prop({ hidden: true, disabled: true });
			$('#cities option[value="#"]', group).prop('selected', true);
			// $('#cities option[disabled]', group).prop({ selected: true, hidden: false, disabled: true });
			$('#cities option[data-state="' + state + '"]', group).prop({ hidden: false, disabled: false });
			$('#form-field-cities', group).show();
			$('#form-field-facilities', group).hide();
			$('#form-field-button', group).hide();
		});
		$('#cities', group).on('change', function() {
			var city_state = $(this).val();
			// $('#facilities option', group).hide();
			// $('#facilities option[disabled]', group).prop('selected', true).show();
			// $('#facilities option[data-city-state="' + city_state + '"]', group).show();
			$('#facilities option', group).not('[value="#"]').prop({ hidden: true, disabled: true });
			$('#facilities option[value="#"]', group).prop('selected', true);
			// $('#facilities option[disabled]', group).prop({ selected: true, hidden: false, disabled: true });
			$('#facilities option[data-city-state="' + city_state + '"]', group).prop({ hidden: false, disabled: false });
			$('#form-field-facilities', group).show();
			$('#form-field-button', group).hide();
		});
		$('#facilities', group).on('change', function() {
			var value = $(this).val();
			var provider_url = '';
			if ($(this).find(':selected').attr('data-parisweb-url') !== undefined) {
				var provider_url = $(this).find(':selected').attr('data-parisweb-url');
			}
			$('#form-field-button a', group).addClass('button-disabled');
			$('#form-field-button .form-card-message', group).empty().text('This facility has not been set up yet. Check back soon.');
			console.log('provider_url', provider_url);
			if (provider_url !== '#') {
				$('#form-field-button .form-card-message', group).empty();
				$('#form-field-button a', group).attr('href', provider_url).removeClass('button-disabled').show();
				$('#form-field-button', group).show();
			} else {
				$('#form-field-button .form-card-message', group).empty();
				$('#form-field-button a', group).attr('href', provider_url).addClass('button-disabled').hide();
				$('#form-field-button .form-card-message', group).empty().text('Please use the hourly parking log in form.');
				$('#form-field-button', group).show();
				setTimeout(function() {
					var width = $(window).width();
					if (width < 800) {
						$('html, body').animate({
							scrollTop: $('#internal').offset().top - 24
						}, 50);
					}
					$('#internal').addClass('piv-login-box-active');
				}, 500);
			}
		});
	}

	$('.button-disabled').on('click', function(e) {
		e.preventDefault();
	});

});
